import React from 'react';

function ModernWhatsAppModal({ isOpen, onClose, telefone }) {
  console.log('🔔 ModernWhatsAppModal - Props recebidas:', { isOpen, telefone });

  if (!isOpen || !telefone) {
    console.log('⛔ Modal não será exibido - isOpen:', isOpen, 'telefone:', telefone);
    return null;
  }

  console.log('✅ Modal será exibido!');

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Formatar telefone removendo caracteres especiais
  const formatarTelefone = (tel) => {
    return tel.replace(/\D/g, ''); // Remove tudo que não for dígito
  };

  const telefoneFormatado = formatarTelefone(telefone);
  const whatsappLink = `https://wa.me/55${telefoneFormatado}`;

  return (
    <div
      className="overlay"
      onClick={handleBackdropClick}
      aria-labelledby="whatsapp-modal-title"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
    >
      <div
        className="modal-modern modal-md"
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '24px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)'
        }}
      >
        {/* Header do modal */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 className="mb-2 fw-bold" id="whatsapp-modal-title">
              <i className="bi bi-whatsapp text-success me-2"></i>
              Pedido Realizado com Sucesso!
            </h5>
            <p className="text-muted mb-0">
              Deseja entrar em contato com a loja via WhatsApp?
            </p>
          </div>
          <button
            type="button"
            className="btn btn-link p-2"
            onClick={onClose}
            aria-label="Fechar modal"
            style={{ fontSize: '1.2rem', color: '#6c757d' }}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {/* Conteúdo do modal */}
        <div className="modal-body">
          <div className="text-center py-3">
            <div
              className="mb-4"
              style={{
                fontSize: '4rem',
                color: '#25D366'
              }}
            >
              <i className="bi bi-whatsapp"></i>
            </div>

            <p className="mb-4 text-muted">
              Fale conosco para tirar dúvidas sobre seu pedido, confirmar detalhes ou receber atualizações sobre a entrega.
            </p>

            {/* Botão WhatsApp */}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-success w-100 mb-3 d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: '#25D366',
                borderColor: '#25D366',
                padding: '12px 24px',
                fontSize: '1.1rem',
                fontWeight: '600',
                borderRadius: '8px'
              }}
              onClick={onClose}
            >
              <i className="bi bi-whatsapp me-2"></i>
              Entrar em Contato
            </a>

            {/* Botão Não, obrigado */}
            <button
              className="btn btn-outline-secondary w-100"
              onClick={onClose}
              style={{
                padding: '10px 24px',
                borderRadius: '8px'
              }}
            >
              Não, obrigado
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModernWhatsAppModal;
